<template>
  <!--begin::App-->
  <div class="d-flex flex-column flex-root app-root" id="kt_app_root">
    <!--begin::Page-->
    <div class="app-page flex-column flex-column-fluid pb-10" id="kt_app_page">
      <div class="header py-5 px-20 mb-10">
        <router-link to="/">
          <img alt="Logo" src="/images/layout/logo-pixel-principal.png" class="h-40px" />
        </router-link>
      </div>
      <div class="col-11 col-md-5 mx-auto mt-10">
        <div class="title-color1">
          <h6 class="title px-4 mx-5">
            <img src="/images/v2/layout/icon-security.svg" alt="icon edit" class="icon" />
            <span>{{ $t('2f_authentication') }}</span>
          </h6>
        </div>
        <p class="text-center mt-4 fw-500 text-color11">{{ $t('info_code_2fa') }}</p>
        <form @submit.prevent="submit" class="text-center default-form">
          <div class="form-group col-5 mx-auto">
            <label class="form-label">{{ $t('verification_code') }}</label>
            <input type="text" class="form-control" v-model.trim="$v.form.code.$model" placeholder="" />
          </div>
          <div class="text-center mt-3">
            <a href="#" @click.prevent="reSendCode" class="mb-3 d-block">
              <template v-if="isResending2FA">
                <Loader
                  :size="'small'"
                  :align="'start'"
                />
              </template>
              <template v-else>
                {{ $t('didnt_receive_it') }} <br>{{ $t('send_code_again') }}
              </template>
            </a>
            <Button
              type="submit"
              class="btn-color10"
              :disabled="$v.$invalid"
              :loading="loader"
            >
              {{ $t('enter') }}
            </Button>
          </div>
        </form>
      </div>
    </div>
    <!--end::Page-->
    <TheFooter />
  </div>
  <!--end::App-->
</template>

<script>

import AuthService from '@/modules/auth/services/auth-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button'
import TheFooter from '@/components/footers/TheFooter'

export default {
  name: 'TwoFactorAuthentication',
  components: {
    Button,
    TheFooter
  },
  data () {
    return {
      loader: false,
      isResending2FA: false,
      form: {
        code: '',
        email: ''
      }
    }
  },
  metaInfo () {
    return {
      title: this.$t('2f_authentication')
    }
  },
  validations () {
    return {
      form: {
        code: { required },
        email: { required }
      }
    }
  },
  created () {
    if (this.userEmail) this.form.email = this.userEmail
    else this.$router.push('/')
  },
  watch: {
    userEmail (email) {
      this.form.email = email
    }
  },
  computed: {
    ...mapState('auth', ['userEmail'])
  },
  methods: {
    /**
     * Resend 2FA code
     */
    async reSendCode () {
      this.isResending2FA = true
      this.content = null
      try {
        await AuthService.resend2FACode({ email: this.form.email })
        const notification = {
          notification: {
            type: 'success',
            content: this.$t('info_new_code_2fa')
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.isResending2FA = false
    },
    reset () {
      this.form.code = ''
    },
    /**
     * Send 2FA code
     */
    async submit () {
      this.loader = true
      try {
        await AuthService.validate2FACode(this.form)
        location.reload()
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>

<style lang="scss" scoped>
#kt_app_root {
  background-color: #fff;
}

.header {
  box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
}
</style>
